// extracted by mini-css-extract-plugin
export default {"Emojis__item":"bfh_a bhe_wh bhe_sq bhe_xj"};